const navbar = {
  favorites: 'Favoritos',
  home: 'Inicio',
  applications: 'Postulaciones',
  profile: 'Mi Perfil',
}

export default navbar
